import { hashObject, stringifyParams } from './helpers';

export default class PrerenderQueue {
  private static DELAY = 500;

  private static get timer() {
    return window.prerenderQueueTimer;
  }

  private static set timer(value: any) {
    window.prerenderQueueTimer = value;
  }

  private static get queue() {
    if (window.prerenderQueue === undefined) {
      window.prerenderQueue = [];
    }

    return window.prerenderQueue;
  }

  private static set queue(value: Array<string>) {
    window.prerenderQueue = value;
  }

  public static get ready() {
    return window.prerenderReady;
  }

  public static set ready(value: boolean) {
    window.prerenderReady = value;
    // console.log('Prerender Ready');
  }

  public static add(key?: string) {
    if (PrerenderQueue.ready || !key) return;

    // console.log('Prerender Queue: Add >>', key, PrerenderQueue.queue);

    PrerenderQueue.queue.push(key);
  }

  public static remove(key?: string) {
    if (PrerenderQueue.ready || !key) return;

    // console.log('Prerender Queue: Remove >>', key, PrerenderQueue.queue);

    const index = PrerenderQueue.queue.indexOf(key);
    if (index !== -1) {
      PrerenderQueue.queue.splice(index, 1);
    }

    PrerenderQueue.next();
  }

  public static next() {
    if (PrerenderQueue.ready) return;
    clearTimeout(PrerenderQueue.timer);

    PrerenderQueue.timer = setTimeout(() => {
      if (PrerenderQueue.queue.length === 0) {
        PrerenderQueue.ready = true;
      }
    }, PrerenderQueue.DELAY);
  }

  public static getKey({
    method = '',
    url = '',
    params = {},
  }: {
    method?: string;
    url?: string;
    params?: any;
  }) {
    return hashObject({
      content: {
        method,
        url,
        params: params ? stringifyParams(params) : '',
      },
      keys: ['method', 'url', 'params'],
    });
  }
}
